interface ActivityStatsProps {
  stats: { d1: number; d7: number; d30: number; d365: number } | undefined
}

const periods = [
  { key: 'd1' as const, label: 'Today', days: 1 },
  { key: 'd7' as const, label: 'Past 7 days', days: 7 },
  { key: 'd30' as const, label: 'Past 30 days', days: 30 },
  { key: 'd365' as const, label: 'Past year', days: 365 },
]

export function ActivityStats({ stats }: ActivityStatsProps) {
  const data = stats ?? { d1: 0, d7: 0, d30: 0, d365: 0 }
  const maxTotal = Math.max(...periods.map((p) => data[p.key]), 1)

  return (
    <div className="border-border flex h-full flex-col justify-between rounded-lg border p-4">
      <div className="text-muted-foreground mb-3 text-sm font-medium">
        Problems Solved
      </div>
      <div className="flex flex-1 flex-col justify-between gap-3">
        {periods.map((period) => {
          const count = data[period.key]
          const barWidth = (count / maxTotal) * 100
          const avg =
            period.days > 1 ? Math.round((count / period.days) * 10) / 10 : null

          return (
            <div key={period.key}>
              <div className="mb-1 flex items-baseline justify-between">
                <span className="text-muted-foreground text-xs">
                  {period.label}
                </span>
                <div className="text-right">
                  <span className="text-foreground text-sm font-semibold">
                    {count}
                  </span>
                  {avg !== null && (
                    <span className="text-muted-foreground ml-1.5 text-xs">
                      ({avg} avg/day)
                    </span>
                  )}
                </div>
              </div>
              {/* Bar */}
              <div className="bg-muted/50 h-2 w-full overflow-hidden rounded-full">
                <div
                  className="h-full rounded-full transition-all"
                  style={{
                    width: `${barWidth}%`,
                    backgroundColor: '#40c463',
                  }}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
